var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M0.227156 10.3098L9.55116 0.985813C9.6967 0.840045 9.89417 0.758036 10.1002 0.757812H15.9942C16.4063 0.757813 16.8016 0.921537 17.093 1.21297C17.3844 1.5044 17.5482 1.89967 17.5482 2.31181V8.20581C17.5486 8.30824 17.5287 8.40974 17.4898 8.50448C17.4508 8.59921 17.3935 8.68531 17.3212 8.75781L7.99716 18.0798C7.92498 18.1521 7.83926 18.2095 7.74488 18.2487C7.6505 18.2878 7.54933 18.308 7.44716 18.308C7.34498 18.308 7.24381 18.2878 7.14943 18.2487C7.05506 18.2095 6.96933 18.1521 6.89716 18.0798L0.227156 11.4078C0.0816986 11.2621 0 11.0647 0 10.8588C0 10.6529 0.0816986 10.4555 0.227156 10.3098ZM12.8852 6.97381C13.1925 6.97381 13.493 6.88267 13.7485 6.71192C14.0041 6.54116 14.2032 6.29846 14.3209 6.0145C14.4385 5.73055 14.4693 5.41809 14.4093 5.11664C14.3493 4.8152 14.2013 4.5383 13.984 4.32097C13.7667 4.10364 13.4898 3.95563 13.1883 3.89567C12.8869 3.83571 12.5744 3.86649 12.2905 3.9841C12.0065 4.10172 11.7638 4.3009 11.5931 4.55646C11.4223 4.81201 11.3312 5.11246 11.3312 5.41981C11.3312 5.83196 11.4949 6.22722 11.7863 6.51866C12.0777 6.81009 12.473 6.97381 12.8852 6.97381Z",
          fill: "#1C1B1F",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }